import Request from '@/utils/axios'
import config from '@/config'

const timeout = config.timeout * 1000;
const baseURL = config.baseURL;
const baseURLSso = process.env.VUE_APP_API_SSO;

export const axiosSso = new Request(baseURLSso, timeout);
export const axios = new Request(baseURL, timeout);